module.exports = __webpack_public_path__ + "static/media/search-bold.1a3658bf.svg";